import { Button } from '@any-ui-react/core';
import { type ReactNode, useState } from 'react';

import { ModalFooter } from '@/common/components/shared/modal-footer/ModalFooter';

interface Props {
  successButtonText?: ReactNode;
  onSuccess: () => void | Promise<void>;
  onClose: () => void;
}

export const DeleteRecordModalContent = ({ successButtonText, onSuccess, onClose }: Props) => {
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <span>The process cannot be undone.</span>
      <ModalFooter>
        <Button variant="default" onClick={onClose}>
          Cancel
        </Button>
        <Button
          className="bg-failure hover:bg-failure"
          loading={loading}
          type="submit"
          onClick={async () => {
            setLoading(true);
            await onSuccess();
            onClose();
            setLoading(false);
          }}
        >
          {successButtonText ?? 'Delete'}
        </Button>
      </ModalFooter>
    </div>
  );
};
